<div class="landscape-wrapper">
  <div class="lp-header">
    <div class="lp-left-top">
      <div class="brand-block">
        <i class="gpr-logo"></i>
        <div class="brand-text">{{ 'PRINT_PAGE.MATERIAL' | translate }}</div>
      </div>
    </div>

    <div class="lp-left-title">
      <div class="report">{{ 'PRINT_PAGE.REPORT' | translate }}</div>
      <h1 class="title">{{ pageTitle | translate }}</h1>
    </div>

    <div class="row meta-row">
      <div class="col-md-5">
        <div class="calc-meta">
          <div class="calc-name">
            {{ 'PRINT_PAGE.CALCULATION_NAME' | translate }}: {{ calculationName }}
          </div>
          <div class="prepared-by">
            {{ 'PRINT_PAGE.PREPARED_BY' | translate }}: {{ preparedBy }}, {{organisationName}}
          </div>
        </div>
      </div>

      <div class="col-md-1 empty-space"></div>
      <div class="col-md-3">
        <div class="printdate" *ngIf="printDate">
          <div class="label">{{ 'PRINT_PAGE.PRINT_DATE' | translate }}</div>
          <div class="value">{{ printDate | date:'dd-MM-yyyy' }}</div>
        </div>
      </div>

      <div class="col-md-3 empty-space"></div>
    </div>
  </div>

  <div class="row cards-row">
    <div class="col-md-6">
      <div class="project-card">
        <div class="sbheader">{{ 'PRINT_PAGE.PROJECT_FEATURES' | translate }}</div>

        <div class="card-columns">
          <div class="col">
            <div class="section-title">{{ 'PROJECT_CHARACTERISTICS.PROJECT_LOCATION' | translate }}</div>
            <div class="lab">{{ 'PRINT_PAGE.ADDRESS' | translate }}</div>
            <div class="fld">{{ projectCharacteristics.streetName }} {{ projectCharacteristics.houseNumber }} {{ projectCharacteristics.houseLetter }}</div>
            <div class="lab">{{ 'PROJECT_CHARACTERISTICS.POSTAL_CODE' | translate }}</div>
            <div class="fld">{{ projectCharacteristics.postalCode }}</div>
            <div class="lab">{{ 'PROJECT_CHARACTERISTICS.TOWN' | translate }}</div>
            <div class="fld">{{ projectCharacteristics.town }}</div>
          </div>

          <div class="col divider">
            <div class="section-title">{{ 'PROJECT_CHARACTERISTICS.PROJECT_ORGANISATION' | translate }}</div>
            <div class="lab">{{ 'PROJECT_CHARACTERISTICS.CLIENT' | translate }}</div>
            <div class="fld">{{ projectCharacteristics.client }}</div>
            <div class="lab">{{ 'PROJECT_CHARACTERISTICS.ARCHITECT' | translate }}</div>
            <div class="fld">{{ projectCharacteristics.architect }}</div>
            <div class="lab">{{ 'PRINT_PAGE.DATE_OF_PERMIT' | translate }}</div>
            <div class="fld">{{ projectCharacteristics.buildingPermitDate | date : 'dd MMMM yyyy' }}</div>
          </div>

          <div class="col divider" >
            <div class="section-title">{{ 'PROJECT_CHARACTERISTICS.PROJECT_STATUS' | translate }}</div>
            <div class="lab">{{ 'PROJECT_CHARACTERISTICS.PHASE' | translate }}</div>
            <div class="fld">{{ projectCharacteristics.phaseId | phaseLabel }}</div>
            <div class="lab">{{ 'PROJECT_CHARACTERISTICS.STATUS' | translate }}</div>
            <div class="fld">
              {{
                            projectCharacteristics.statusId === 0
                            ? ('PROJECT_CHARACTERISTICS.STATUS_DEFAULT' | translate)
                            : ('PROJECT_CHARACTERISTICS.STATUS_FINAL' | translate)
              }}
            </div>
            <div class="lab">{{ 'PROJECT_CHARACTERISTICS.PURPOSE' | translate }}</div>
            <div class="fld" [innerHTML]="projectCharacteristics.purposeValue | purposeLabel"></div>
          </div>
        </div>
      </div>
    </div>

    <div [ngClass]="hasThreeOrMoreColumns() ? 'col-md-6' : 'col-md-4'">
      <div class="building-card">
        <div class="sbheader">{{ 'HEADER.BUILDING_CHARACTERISTICS' | translate }}</div>

        <div class="card">

          <!-- New building -->
          <ng-container *ngIf="!isExistingBuildingCal">
            <div class="section-title">
              {{ 'BUILDING_CHARACTERISTICS.BUILDING' | translate }}
            </div>

            <ng-container *ngFor="let mainCharacteristic of printData.mainCharacteristics">
              <ng-container *ngIf="mainCharacteristic.parameters">
                <div class="card-columns building-params-columns">
                  <ng-container *ngFor="let paramGroup of getParameterGroups(mainCharacteristic); let groupIndex = index">
                    <div class="col" [class.divider]="groupIndex > 0">
                      <ng-container *ngFor="let parameter of paramGroup">
                        <div *ngIf="!isJsonValue(parameter.value)">
                          <div class="lab">{{ parameter.name }}</div>

                          <div class="fld">
                            {{ parameter.value ? (parameter.value + '').split('.').join(',') : '-' }}

                            <span *ngIf="parameter.value &&
                                            (parameter.name === ('PRINT_PAGE.BVO_PARAMETER' | translate) ||
                                             parameter.name === ('PRINT_PAGE.GBO_PARAMETER' | translate))">
                              {{ 'PRINT_PAGE.BVO_UNIT' | translate }}
                            </span>

                            <span *ngIf="parameter.value &&
                                            parameter.name === ('PRINT_PAGE.BUILDING_LIFESPAN_PARAMETER' | translate)">
                              {{ 'MESSAGES.YEAR' | translate }}
                            </span>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </ng-container>
                </div>
              </ng-container>
            </ng-container>
          </ng-container>


          <!-- Existing building -->
          <ng-container *ngIf="isExistingBuildingCal">
            <div class="section-title">
              {{ 'BUILDING_CHARACTERISTICS.EXISTING_BUILD' | translate }}
            </div>

            <ng-container *ngFor="let existingBuilding of printData.mainCharacteristics">

              <div class="card-columns existing-building-columns">

                <ng-container *ngFor="let buildingElement of existingBuilding.existingBuildingElements; let i = index">

                  <div class="col existing-building-column"
                       [class.divider]="i > 0">

                    <div class="existing-building-title">
                      {{ buildingElement.elementName | titlecase }}
                    </div>

                    <ng-container *ngFor="let parameter of buildingElement.parameters">
                      <div *ngIf="!isJsonValue(parameter.value)">
                        <div class="lab">
                          {{ parameter.name }}
                        </div>

                        <div class="fld">
                          <span [id]="parameter.name + i">
                            {{
 parameter.value
                                            ? (parameter.value + '').split('.').join(',')
                                            : '-'
                            }}
                          </span>

                          <span *ngIf="parameter.value &&
                                        (parameter.name === ('PRINT_PAGE.BVO_PARAMETER' | translate) ||
                                         parameter.name === ('PRINT_PAGE.GBO_PARAMETER' | translate))">
                            {{ 'PRINT_PAGE.BVO_UNIT' | translate }}
                          </span>

                          <span *ngIf="parameter.value &&
                                        parameter.name === ('PRINT_PAGE.BUILDING_LIFESPAN_PARAMETER' | translate)">
                            {{ 'MESSAGES.YEAR' | translate }}
                          </span>
                        </div>
                      </div>
                    </ng-container>


                    <!-- Huidig lifespan -->
                    <div class="lifespan-block"
                         *ngIf="buildingElement.elementName === 'Huidig'">

                      <div class="lifespan-item">
                        <div class="lab">
                          {{ 'BUILDING_CHARACTERISTICS.LIFESPAN' | translate }}
                        </div>
                        <div class="fld">
                          {{ levensduurHuidig }}
                          {{ 'BUILDING_CHARACTERISTICS.YEAR' | translate }}
                        </div>
                      </div>

                      <div class="lifespan-item">
                        <div class="lab">
                          {{ 'BUILDING_CHARACTERISTICS.REMAINING_LIFESPAN' | translate }}
                        </div>
                        <div class="fld">
                          {{ resterendLevensduurHuidig }}
                          {{ 'BUILDING_CHARACTERISTICS.YEAR' | translate }}
                        </div>
                      </div>
                    </div>


                    <!-- Ingreep lifespan -->
                    <div class="lifespan-block"
                         *ngIf="buildingElement.elementName === 'Ingreep'">

                      <div class="lifespan-item">
                        <div class="lab">
                          {{ 'BUILDING_CHARACTERISTICS.LIFESPAN' | translate }}
                        </div>
                        <div class="fld">
                          {{ levensduurIngreep }}
                          {{ 'BUILDING_CHARACTERISTICS.YEAR' | translate }}
                        </div>
                      </div>

                      <div class="lifespan-item">
                        <div class="lab">
                          {{ 'BUILDING_CHARACTERISTICS.REMAINING_LIFESPAN' | translate }}
                        </div>
                        <div class="fld">
                          {{ resterendLevensduurIngreep }}
                          {{ 'BUILDING_CHARACTERISTICS.YEAR' | translate }}
                        </div>
                      </div>
                    </div>

                  </div>
                </ng-container>

              </div>
            </ng-container>
          </ng-container>

        </div>
      </div>
    </div>

    <div [ngClass]="hasThreeOrMoreColumns() ? 'hidediv' : 'col-md-2 empty-space'"></div>
  </div>

  <div class="accountability">
    <h6>{{ 'PRINT_PAGE.ACCOUNTABILITY' | translate }}</h6>
    <small [innerHTML]="'PRINT_PAGE.ACCOUNTABILITY_MESSAGE' | translate:{
            materialsAppVersionNumber: printData.materialsAppVersionNumber || 0,
            lastNmdProductUpdateDate: (printData.lastNmdProductUpdateDate | date : 'dd MMMM yyyy'),
            organisationName: printData.organisationName
         }">
    </small>
  </div>
</div>
